// extracted by mini-css-extract-plugin
module.exports = {"beta":"Beta_beta__2ALYK"};